import React from "react";
import { KeyRound, Unlock, Cpu, Wrench, Copy, Cog, Car, Droplet, Disc, ArrowRight } from "lucide-react";
import { services, businessInfo } from "../mock";

const iconMap = { KeyRound, Unlock, Cpu, Wrench, Copy, Cog, Car, Droplet, Disc };

const Services = () => {
  return (
    <section id="services" className="py-20 lg:py-28 diamond-plate relative">
      <div className="absolute inset-0 fire-bg-subtle opacity-60 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl">
          <span className="text-yellow-400 font-bold uppercase tracking-[0.3em] text-xs">What I Do</span>
          <h2 className="mt-3 text-white font-extrabold text-3xl lg:text-5xl tracking-tight heading-underline">
            Mobile Locksmith Services
          </h2>
          <p className="mt-6 text-zinc-400 text-lg leading-relaxed">
            Automotive Key Replacement, Diagnostics, Module Programming &amp; Cloning, plus oil changes, brakes, filters, and other basic mobile maintenance — a fully equipped van and the experience to do it right the first time.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((svc) => {
            const Icon = iconMap[svc.icon] || KeyRound;
            return (
              <div key={svc.id} className="svc-card p-7 rounded-xl brand-card">
                <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-red-600 to-red-900 flex items-center justify-center shadow-lg shadow-red-900/40">
                  <Icon className="w-6 h-6 text-white" strokeWidth={2.2} />
                </div>
                <h3 className="mt-5 font-bold text-white text-xl">{svc.title}</h3>
                <p className="mt-2 text-zinc-400 text-sm leading-relaxed">{svc.description}</p>
                <ul className="mt-4 space-y-1.5">
                  {svc.features.map((f, i) => (
                    <li key={i} className="text-sm text-zinc-300 flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-yellow-400" />
                      {f}
                    </li>
                  ))}
                </ul>
                <a href={`tel:${businessInfo.phoneRaw}`} className="mt-5 inline-flex items-center gap-1.5 text-red-500 font-semibold text-sm hover:gap-2.5 hover:text-red-400 transition-all">
                  Call for service <ArrowRight className="w-4 h-4" />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
